window.htmx = require('htmx.org/dist/htmx.js');
